export enum LoadingType {
    Loading = 'loading',
    Unloading = 'unloading',
}

export interface LoadingContact {
    id?: number;
    suggestion_id?: number;
    phone?: string | null;
    no_email: number;
    name?: string | null;
    email?: string | null;
    loading_id: number | null;
    deleted?:boolean;
}

interface Loading {
    id?: number;
    order_id: number;
    type: LoadingType;
    country_id?: number | null;
    country?: number | null;
    city?: string | null;
    address?: string | null;
    zip?: string | null;
    company?: string | null;
    deleted_at?: Date | null;
    created_at?: Date | null;
    updated_at?: Date | null;
    contacts: LoadingContact[] | null;
    deleted?: boolean;
}

export default Loading;
